import React from 'react';
import { Spacing } from '../../../layout/Spacing/Spacing';
import { FlexCenter } from '../../../layout/FlexCenter/FlexCenter';
import { PanelLayout } from '../../../layout/Panel/Panel';
import { TextCustom } from '../../../ui/TextCustom';
import { Badge } from '../../../shared/Badge/Badge';

interface ICurrentDepartmentProps {
    label: string;
    title: string;
}

export const CurrentDepartment: React.FC<ICurrentDepartmentProps> = ({ label, title }) => {
    return (
        <Spacing marginSpacing={'m'} paddingSpacing={'m'}>
            <PanelLayout hasShadow={false} isBlock isRelative colorIntensity={0.7} colorBorder="accent-green" borderIntensity={0.1}>
                <Spacing marginSpacing={'m'} paddingSpacing={'m'}>
                    <FlexCenter position="start" direction="v">
                        <TextCustom color="grey-dark" size={1}>
                            {label}
                        </TextCustom>
                        {/* <Title text={title} size={'l'} color='accent-green'/> */}
                        <Badge color="accent-green" label={title} />
                    </FlexCenter>
                </Spacing>
            </PanelLayout>
        </Spacing>
    );
};
